import { useDisclosure } from "@heroui/react";
import { toast } from "react-toastify";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { api } from "@/api";
import { getIdFromCategoryHandbook } from "@/utils/getIdFromHandbook.ts";
import { InputField } from "../../forms/formBuilder";
import { FormModalBuilder, ModalError } from "../formModalBuilder";
import { useState } from "react";
import useErrorHandling from "@/hooks/useErrorHandling";

interface CreateToPlatformTicketForm {
  subject: string;
  category: number;
  office: number;
  visible_to_company: boolean;
}

const createToPlatformTicketFields: InputField[] = [
  {
    label: "Тема обращения",
    name: "subject",
    placeholder: "Введите тему обращения",
    type: "text",
  },
  {
    label: "Категория",
    name: "category",
    placeholder: "",
    type: "to-platform-category",
  },
  {
    label: "Доступно компании",
    name: "visible_to_company",
    placeholder: "",
    type: "boolean",
  },
];

export function CreateToPlatformTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const user = useAppSelector((state) => state.user.currentUser.id);

  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);
  const handleError = useErrorHandling();

  const onSubmit = (data: CreateToPlatformTicketForm) => {
    return new Promise<boolean>((resolve) => {
      Promise.all([getIdFromCategoryHandbook(String(data.category))])
        .then(([category]) => {
          return api.tickets.create({
            subject: data.subject,
            type: "to_platform",
            category: Number(category),
            user_id: user!,
            visible_to_company: data.visible_to_company,
          });
        })
        .then(() => {
          disclosure.onClose();
          toast.success("Тикет успешно создан");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <FormModalBuilder
      modalErrors={modalErrors}
      title="Создание тикета к платформе"
      fields={createToPlatformTicketFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
